@if (isLoaderVisible) {
    <div id="preloader" [ngClass]="{ 'loader-local': isLocal }">
        <div id="loader"></div>
    </div>
}
